import { render } from "./PrescriberSignature.vue?vue&type=template&id=74066788"
import script from "./PrescriberSignature.vue?vue&type=script&lang=js"
export * from "./PrescriberSignature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__